/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Cookies_ErrorInputs */

const en_privacy_cookies_error = /** @type {(inputs: Privacy_Cookies_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error monitoring (Sentry): `)
};

const de_privacy_cookies_error = /** @type {(inputs: Privacy_Cookies_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlerueberwachung (Sentry): `)
};

const fr_privacy_cookies_error = /** @type {(inputs: Privacy_Cookies_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivi des erreurs (Sentry) : `)
};

const es_privacy_cookies_error = /** @type {(inputs: Privacy_Cookies_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitorización de errores (Sentry): `)
};

const it_privacy_cookies_error = /** @type {(inputs: Privacy_Cookies_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitoraggio errori (Sentry): `)
};

const nl_privacy_cookies_error = /** @type {(inputs: Privacy_Cookies_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foutmonitoring (Sentry): `)
};

const pl_privacy_cookies_error = /** @type {(inputs: Privacy_Cookies_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitorowanie błędów (Sentry): `)
};

const fi_privacy_cookies_error = /** @type {(inputs: Privacy_Cookies_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virheseuranta (Sentry): `)
};

const da_privacy_cookies_error = /** @type {(inputs: Privacy_Cookies_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fejlovervågning (Sentry): `)
};

const sv_privacy_cookies_error = /** @type {(inputs: Privacy_Cookies_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Felövervakning (Sentry): `)
};

/**
* | output |
* | --- |
* | "Error monitoring (Sentry):" |
*
* @param {Privacy_Cookies_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_cookies_error = /** @type {((inputs?: Privacy_Cookies_ErrorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Cookies_ErrorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_cookies_error(inputs)
	if (locale === "fr") return fr_privacy_cookies_error(inputs)
	if (locale === "es") return es_privacy_cookies_error(inputs)
	if (locale === "it") return it_privacy_cookies_error(inputs)
	if (locale === "nl") return nl_privacy_cookies_error(inputs)
	if (locale === "pl") return pl_privacy_cookies_error(inputs)
	if (locale === "fi") return fi_privacy_cookies_error(inputs)
	if (locale === "da") return da_privacy_cookies_error(inputs)
	if (locale === "sv") return sv_privacy_cookies_error(inputs)
	return en_privacy_cookies_error(inputs)
});